import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { LivePackageEntity } from '../../domain/entities/LivePackageEntity'
import type { PackageStreamingAdminDto } from '@/backend/market'
export class LivePackageModel extends LivePackageEntity {
  constructor(dataDto: PackageStreamingAdminDto) {
    super()
    mapEntityProperties<LivePackageEntity>(this, dataDto, {
      map: {
        vehicleTemplateType: dataDto.vehicleTemplateType
      }
    })
  }
}
